"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearState = exports.setCurrentPage = exports.setItemsPerPage = exports.unselect = exports.select = exports.fetchFailed = exports.fetchSuccess = exports.fetchRequest = void 0;
const actionTypes = require("../../actionTypes/order/distributionLists");
const fetchRequest = (project) => ({
    type: actionTypes.FETCH_REQUEST,
    payload: project
});
exports.fetchRequest = fetchRequest;
const fetchSuccess = (lists) => ({
    type: actionTypes.FETCH_SUCCESS,
    payload: lists
});
exports.fetchSuccess = fetchSuccess;
const fetchFailed = (error) => ({
    type: actionTypes.FETCH_FAILED,
    payload: error
});
exports.fetchFailed = fetchFailed;
const select = (ids) => ({
    type: actionTypes.SELECT,
    payload: {
        ids
    }
});
exports.select = select;
const unselect = (ids) => ({
    type: actionTypes.UNSELECT,
    payload: {
        ids
    }
});
exports.unselect = unselect;
const setItemsPerPage = (itemsPerPage) => ({
    type: actionTypes.SET_ITEMS_PER_PAGE,
    payload: {
        itemsPerPage
    }
});
exports.setItemsPerPage = setItemsPerPage;
const setCurrentPage = (currentPage) => ({
    type: actionTypes.SET_CURRENT_PAGE,
    payload: {
        currentPage
    }
});
exports.setCurrentPage = setCurrentPage;
const clearState = () => ({
    type: actionTypes.CLEAR
});
exports.clearState = clearState;
//# sourceMappingURL=distributionLists.js.map